import { user } from '@/components/User.js';
import { interval } from '@/components/Interval.js';
import { server } from '@/components/Server.js';
import { workplaceTypes } from '@/types.js';
import { modalContainer } from '@/Modal/ModalContainer';
import m from 'mithril';

export const appNotification = {
    intervalTimerId: null,
    notifications: [],
    notes: [],
    filteredNotes: [],
    flight_id: '',

    init: function () {
        if (appNotification.available() && !appNotification.intervalTimerId) {
            appNotification.intervalTimerId = interval.make(async () => {
                await appNotification.load(true);
            }, 60000);
        }
    },
    load: async function (withSound, showHistory = false) {
        try {
            const response = await m.request({
                method: 'GET',
                url: '/api/notifications',
                background: true,
            })

            server.setOnline();
            appNotification.notifications = response.list.notifications;
            appNotification.notes = response.list.notes;

            const flightId = localStorage.getItem("flightId");
            appNotification.flight_id = JSON.parse(flightId) || '';
            appNotification.filterNotes()

            if (appNotification.notifications.length > 0) {
                modalContainer.open();
                const audio = document.querySelector('.sound-playback');
                if (withSound && audio) {
                    audio.play().then(() => console.log("Звук играет!")).catch(e => console.error("Ошибка:", e));
                }
            }

            if (this.filteredNotes.length > 0 && this.filteredNotes.some(note => !note.IsRead)) {
                modalContainer.open();
            }

            if (showHistory) {
                modalContainer.open();
            }
        } catch (error) {
            server.setOffline(error.status);
        }        
    },

    markRead: async function (key) {
        const data = this.notifications[key];
        const soundElement = document.querySelector('.alert-sound');

        // Останавливаем звук
        if (soundElement) {
            soundElement.pause();
            soundElement.currentTime = 0;
        }

        if (typeof data === 'undefined') {
            return;
        }

        try {
            await m.request({
                method: 'PUT',
                url: '/api/notification',
                data: {
                    notificationId: data.id,
                    notificationType: data.type
                }
            });

            server.setOnline();
            this.notifications.splice(key, 1);

            if (!this.notifications.length) {
                modalContainer.close();
            }
        } catch (err) {
            server.setOffline(err.status);
        } finally {
            m.redraw();
        }
    },
    markReadNote: function (Notification_ID) {
        m.request({
            method: 'PUT',
            url: '/api/read_note',
            data: {
              Notification_ID: Notification_ID,
            },
            extract(xhr) {
                const statusErr = [401, 403]
                const obj = xhr.response
                return statusErr.includes(xhr.status) ? xhr.status : xhr.response;
            }
        }).then(function () {
            server.setOnline();
            setTimeout(() => {
              appNotification.load()
            }, 1000);
            if (!appNotification.filteredNotes.length) {
                modalContainer.close();
            }

        }, function (err) {
            server.setOffline(err);
        })
    },
    markAllReadNote: function () {
        const taskRoute = m.route.param()
        m.request({
            method: 'PUT',
            url: '/api/read-all-notes',
            data: {
              flight_id: appNotification.flight_id && taskRoute.taskId ? appNotification.flight_id : null,
            },
            extract(xhr) {
                const statusErr = [401, 403]
                const obj = xhr.response
                return statusErr.includes(xhr.status) ? xhr.status : xhr.response;
            }
        }).then(function () {
            server.setOnline();
            setTimeout(() => {
              appNotification.load()
            }, 1000);
            if (!appNotification.filteredNotes.length) {
                modalContainer.close();
            }

        }, function (err) {
            server.setOffline(err);
        })
    },
    filterNotes: function () {
      const taskRoute = m.route.param()

      if (appNotification.flight_id && taskRoute.taskId) {
        appNotification.filteredNotes = appNotification.notes.filter((i) => i.Spp_id == appNotification.flight_id && i.Type == 'По рейсу')
      } else {
        appNotification.filteredNotes = appNotification.notes.filter((i) => !i.Spp_id && i.Type == 'Рабочее');
      }
      modalContainer.redraw()
    },
    stop: function () {
        clearInterval(appNotification.intervalTimerId);
        appNotification.intervalTimerId = null;
        const soundElement = document.querySelector('.alert-sound');
        if (soundElement) {
            soundElement.pause();
            soundElement.currentTime = 0;
        }
    },
    reset: function () {
        // notification.stop();
        appNotification.init();
    },
    available: function () {
        return user ? (
            user.get('state.workplace') === workplaceTypes.supervisor ||
            user.get('state.workplace') === workplaceTypes.executor ||
            user.get('state.workplace') === workplaceTypes.driver
        ) : false
    }
};

export function runAppNotificationTimer() {
    setTimeout(() => {
        if (appNotification.available()) {
            appNotification.load(true)
        }
    }, 1000)
}


